<script lang="ts">
  import type { Widget } from "../store";
import { PaletteType, widgetInfo } from "../store";

let palette: PaletteType = PaletteType.DARK;
widgetInfo.subscribe((value: Widget) => {
  if ( value && value.theme in PaletteType) palette = value.theme;
});
</script>


<div class="pw-{PaletteType[palette].toLowerCase()} pw-background">
    <div class="pw-background-Group">
        <div class="pw-background-Gradient-1">
        </div>
        <div class="pw-background-Gradient-2">
        </div>
        <div class="pw-background-Circles-Group">
            <div class="pw-background-Circles-2">
            </div>
            <div class="pw-background-Circles-1">
            </div>
        </div>

    </div>
    <div class="pw-background-Gradient"></div>
    <!-- {scaryMode && <div className="pw-background-Scary-Gradient"></div>} -->
    
<style scoped>

:root{
  --background: #121A24;
  --background-gradient: linear-gradient(180deg,rgba(0, 0, 0, 0) 0%, #121A24 50%);
  --background-scary-gradient: linear-gradient(180deg, #cf2f266e 0%, rgba(31, 104, 51, 0) 60%);
  --background-gradient-1: linear-gradient(180deg, #022F87 0%, rgba(237, 244, 255, 0.32) 65.84%, rgba(0, 0, 0, 0) 100%);
  --background-gradient-2: linear-gradient(180deg, #11303D 0%, rgba(31, 104, 51, 0) 100%);
  --background-circles-1: linear-gradient(149.87deg, #121A24  62.7%, #FFFFFF 80.21%);
  --background-circles-2: linear-gradient(131.94deg, #121A24  63.52%, #FFFFFF 81.27%);
}

.pw-light{
  --background: #ffffff;
  --background-gradient: linear-gradient(0deg,#fff 50%, rgba(255, 255, 255, 0.5) 100%);
  --background-scary-gradient: linear-gradient(180deg, #F29C8A70 0%, rgba(31, 104, 51, .5) 100%);
  --background-gradient-1: linear-gradient(253.91deg, #11303D -10.4%, rgba(31, 104, 51, .5) 50.41%);
  --background-gradient-2: rgba(0, 0, 0, .5);
  --background-circles-1: linear-gradient(149.87deg, rgba(255, 255, 255, .5) 62.7%, #FFFFFF 80.21%);
  --background-circles-2: linear-gradient(131.94deg, rgba(255, 255, 255, .5) 63.52%, #FFFFFF 81.27%);
}

.pw-background {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  opacity: 1;
  z-index: -1;
  background: var(--background);
}

.pw-background-Group {
  z-index: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  /* might need to change per theme */
  opacity: 0.2; 
}

.pw-background-Gradient {
  z-index: 1;
  position:absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--background-gradient);
}

.pw-background-Scary-Gradient {
  z-index: 1;
  position:absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--background-scary-gradient);
}


.pw-background-Gradient-1 {
  position: absolute;
  height: 100&;
  width: 100%;
  left: 0%;
  right: 0%;
  top: 0px;
  /* add opacity here for light mode */
  background: var(--background-gradient-1);
}

.pw-background-Gradient-2 {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0%;
  right: 0%;
  top: 0px;
  /* pw3 light mode is missing this background */
  background: var(--background-gradient-2);
}

.pw-background-Circles-Group {
  position: absolute;
  overflow: hidden;
  width: 1238px;
  height: 1304.92px;
  right: -628px;
  top: -353.11px;
}

.pw-background-Circles-1 {
  position: absolute;
  height: 1304.92px;
  width: 1238px;
  border-radius: 50%;
  background: var(--background-circles-1);
  mix-blend-mode: overlay;
  opacity: 0.9;
  transform: rotate(-180deg);
  overflow: hidden;

}
.pw-background-Circles-2 {
  position: absolute;
  width: 880.88px;
  height: 928.5px;
  left: 93.64px;
  top: 351.132px;
  border-radius: 50%;
  background: var(--background-circles-2);
  mix-blend-mode: overlay;
  opacity: 0.9;
  transform: rotate(-180deg);
  overflow: hidden;
}
</style>

</div>
